import React from 'react';
import { Bell, Search, Settings } from 'lucide-react';
import { Highlight } from './Highlight';
import { MockWindow } from './MockWindow';
const otherTabs = ['Payment and transfer rules', 'Data connections'];
export function PayoutsMockup() {
  return <MockWindow data-id="element-125" data-mp="1z0d8h5c0l9o8">
      <div className="flex items-center justify-between border-b border-mm-light-gray px-[1.6cqw] py-[0.8cqw]" data-id="element-126" data-mp="1yysk5xgammyt">
        <div className="flex h-[2cqw] w-[16cqw] items-center gap-[0.5cqw] bg-[#F1F1EE] px-[0.7cqw] text-[1cqw] text-mm-mid-gray" data-id="element-127" data-mp="1p2pb07n0xo2d">
          <Search className="h-[1cqw] w-[1cqw]" aria-hidden="true" data-id="element-128" data-mp="1u2ldg2g2p7ft" />
          Search
        </div>
        <div className="flex items-center gap-[1.2cqw] text-mm-mid-gray" data-id="element-129" data-mp="1g2sqmi7o3bd4">
          <div className="h-[1.4cqw] w-[1.4cqw]" aria-hidden="true" data-id="element-130" data-mp="1l0c59j8a1q5l" />
          <Bell className="h-[1.4cqw] w-[1.4cqw]" aria-hidden="true" data-id="element-131" data-mp="1l2oxcp7r1gwd" />
          <Highlight tone="go" tag="1" side="bottom-end" data-id="element-132" data-mp="3agbltle86hv9">
            <Settings className="h-[1.6cqw] w-[1.6cqw] text-mm-charcoal" aria-hidden="true" data-id="element-133" data-mp="3ffern8214s4a" />
          </Highlight>
        </div>
      </div>

      <div className="px-[2cqw] pb-[2cqw] pt-[1.4cqw]" data-id="element-134" data-mp="2538bjjxavky5">
        <p className="text-[1cqw] font-medium text-[#635BFF]" data-id="element-135" data-mp="213pooilx4zso">Settings</p>
        <p className="text-[1.6cqw] font-semibold text-mm-black" data-id="element-136" data-mp="211d7i7nzitgo">Linked accounts and payouts</p>

        <div className="mt-[1cqw] flex items-end gap-[1.6cqw] border-b border-mm-light-gray" data-id="element-137" data-mp="2ewfb2o5d06qb">
          <Highlight tone="go" tag="2" side="bottom" data-id="element-138" data-mp="29xuagnm73l1c">
            <span className="block border-b-[0.15cqw] border-[#635BFF] pb-[0.4cqw] text-[1.05cqw] font-semibold text-[#635BFF]" data-id="element-139" data-mp="1m6ym60gy77yu">
              Linked accounts
            </span>
          </Highlight>
          {otherTabs.map(tab => <span key={tab} className="pb-[0.4cqw] text-[1.05cqw] text-mm-mid-gray" data-id="element-140" data-mp="1w5o3ns4xmqek">
              {tab}
            </span>)}
        </div>

        <div className="mt-[2.8cqw] border border-mm-light-gray p-[1.2cqw]" data-id="element-141" data-mp="37j9xhqlqlg6f">
          <p className="text-[1.1cqw] font-semibold text-mm-black" data-id="element-142" data-mp="37lctcr9km3j2">
            Bank accounts for your payments balance
          </p>
          <div className="mt-[0.8cqw] grid grid-cols-[8cqw_1fr] border-b border-mm-light-gray pb-[0.4cqw] text-[1cqw] font-semibold uppercase tracking-[0.06em] text-mm-mid-gray" data-id="element-143" data-mp="3aleathwasq4w">
            <span data-id="element-144" data-mp="3jljjdvd89ukn">Currency</span>
            <span data-id="element-145" data-mp="3jl9sm5kczjdw">Bank</span>
          </div>
          <div className="grid grid-cols-[8cqw_1fr] items-center py-[0.6cqw] text-[1cqw]" data-id="element-146" data-mp="3jjgiuheg8j1o">
            <span className="flex items-center gap-[0.4cqw] text-mm-charcoal" data-id="element-147" data-mp="3ojusg3vp811t">
              USD
              <span className="bg-[#EEF2FF] px-[0.4cqw] text-[#635BFF]" data-id="element-148" data-mp="2qyp031s5d18r">Default</span>
            </span>
            <span className="text-mm-mid-gray" data-id="element-149" data-mp="2vw8i8cryty5z">
              <span className="text-[#635BFF]" data-id="element-150" data-mp="30ujs2ni9g8o7">Add a bank account</span> to pay out this currency.
            </span>
          </div>
          <Highlight tone="go" tag="3" className="mt-[0.8cqw] inline-block" data-id="element-151" data-mp="35ncsx0alywv0">
            <span className="block border border-mm-light-gray px-[0.8cqw] py-[0.3cqw] text-[1.05cqw] font-semibold text-[#635BFF]" data-id="element-152" data-mp="285cr7hvc36zs">
              + Add bank account
            </span>
          </Highlight>
        </div>
      </div>
    </MockWindow>;
}